import Vue from 'vue'
import store from 'src/assets/store'

Vue.directive('beta', {
  inserted: function (el) {
    if (process.env.PROD && store.state.person?.id > 5) {
      el.style.display = 'none'
    }
  }
})
